import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/4e26ad7192bd77d86f80f09d990bed83/f48196d81798c2f07d880df7a7c3ee26.png" 
                alt="Eco Loft Insulation Installers Coventry" 
                className="h-12 w-auto mb-4"
              />
              <p className="text-gray-300 leading-relaxed">
                Your trusted <strong>Coventry loft insulation specialists</strong>. Eco Loft Insulation Installers brings energy efficiency to homes through expert insulation solutions.
              </p>
            </div>
            
            <div className="space-y-3">
              <div>
                <p className="font-semibold text-emerald-400 mb-1">Business Address:</p>
                <p className="text-gray-300">Access House, Read St, Coventry CV1 5PT</p>
              </div>
              <div>
                <p className="font-semibold text-emerald-400 mb-1">Phone:</p>
                <a href="tel:+442476070153" className="text-gray-300 hover:text-emerald-400 transition-colors">
                  024 7607 0153
                </a>
              </div>
              <div>
                <p className="font-semibold text-emerald-400 mb-1">Email:</p>
                <a href="mailto:info@loftinsulationcoventry.site" className="text-gray-300 hover:text-emerald-400 transition-colors">
                  info@loftinsulationcoventry.site
                </a>
              </div>
              <div>
                <p className="font-semibold text-emerald-400 mb-1">Website:</p>
                <a href="https://www.loftinsulationcoventry.site" className="text-gray-300 hover:text-emerald-400 transition-colors">
                  www.loftinsulationcoventry.site
                </a>
              </div>
              <div>
                <p className="font-semibold text-emerald-400 mb-1">Hours of Operation:</p>
                <p className="text-gray-300 text-sm">
                  Monday – Sunday: 9:00 AM – 7:00 PM
                </p>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-emerald-400 mb-4">Our Services:</h4>
            <ul className="space-y-2">
              <li><a href="/services/loft-insulation" className="text-gray-300 hover:text-emerald-400 transition-colors">Loft Insulation Installation</a></li>
              <li><a href="/services/loft-boarding" className="text-gray-300 hover:text-emerald-400 transition-colors">Loft Boarding</a></li>
              <li><a href="/services/spray-foam-removal" className="text-gray-300 hover:text-emerald-400 transition-colors">Spray Foam Removal</a></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-emerald-400 mb-4">Quick Links:</h4>
            <ul className="space-y-2">
              <li><a href="/about" className="text-gray-300 hover:text-emerald-400 transition-colors">About Us</a></li>
              <li><a href="/process" className="text-gray-300 hover:text-emerald-400 transition-colors">Our Process</a></li>
              <li><a href="/gallery" className="text-gray-300 hover:text-emerald-400 transition-colors">Gallery</a></li>
              <li><a href="/reviews" className="text-gray-300 hover:text-emerald-400 transition-colors">Reviews</a></li>
              <li><a href="/contact" className="text-gray-300 hover:text-emerald-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Social Media & Certifications */}
          <div>
            <h4 className="font-semibold text-emerald-400 mb-4">Follow Us:</h4>
            <div className="flex space-x-4 mb-6">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
            
            <div>
              <h5 className="font-semibold text-emerald-400 mb-2">Certifications:</h5>
              <p className="text-gray-300 text-sm">
                • Fully Insured<br />
                • CIGA Registered<br />
                • TrustMark Approved
              </p>
            </div>
          </div>
        </div>

        {/* Areas We Serve Accordion */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <details className="group">
            <summary className="flex items-center justify-between cursor-pointer text-emerald-400 font-semibold mb-4">
              <span>Areas We Serve</span>
              <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
            </summary>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm text-gray-300">
              <a href="/areas/coventry" className="hover:text-emerald-400 transition-colors">Coventry</a>
              <a href="/areas/warwick" className="hover:text-emerald-400 transition-colors">Warwick</a>
              <a href="/areas/leamington-spa" className="hover:text-emerald-400 transition-colors">Leamington Spa</a>
              <a href="/areas/rugby" className="hover:text-emerald-400 transition-colors">Rugby</a>
              <a href="/areas/nuneaton" className="hover:text-emerald-400 transition-colors">Nuneaton</a>
              <a href="/areas/kenilworth" className="hover:text-emerald-400 transition-colors">Kenilworth</a>
              <a href="/areas/bedworth" className="hover:text-emerald-400 transition-colors">Bedworth</a>
              <a href="/areas/stratford-upon-avon" className="hover:text-emerald-400 transition-colors">Stratford-upon-Avon</a>
            </div>
          </details>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            Copyright © <strong>2025</strong> Eco Loft Insulation Installers - All Rights Reserved
          </p>
          <p className="text-gray-400 text-sm mt-2 md:mt-0">
            <a href="https://readdy.ai/?origin=logo" className="hover:text-emerald-400 transition-colors">Website Builder</a>
          </p>
        </div>
      </div>
    </footer>
  );
};
